/*************************************************************************
 *
 * COMPRO CONFIDENTIAL
 * __________________
 *
 *  [2015] - [2020] Compro Technologies Private Limited
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Compro Technologies Private Limited. The
 * intellectual and technical concepts contained herein are
 * proprietary to Compro Technologies Private Limited and may
 * be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Compro Technologies Pvt. Ltd..
 ***************************************************************************/

/***********************************************************
 * comproDLS SDK Configuration
 * This module provides configuration for comproDLS SDK
 ************************************************************/

/****************************************************
 * Setting up Exports/Public functions and variables
 *****************************************************/

exports.REALM_HOSTS = {
  GLOBAL: {
    PROD1: {
      PUB: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-pub',
      AUTH: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-auth',
      AUTHEXTN: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-authextn',
      PUSHX: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-pushx',
      XAPI: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-xapi',
      ATTEMPTS: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-attempts',
      PRODUCT: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-product',
      ANALYTICS: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-analytics',
      INTEGRATION: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-integrations',
      DRIVE: 'http://internal-dls-global-prod1-1755536919.us-west-2.elb.amazonaws.com/lb-drive'
    }
  },
  ASGARD: {
    THOR: {
      PUB: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-pub',
      AUTH: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-auth',
      AUTHEXTN: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-authextn',
      PUSHX: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-pushx',
      XAPI: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-xapi',
      ATTEMPTS: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-attempts',
      PRODUCT: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-product',
      ANALYTICS: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-analytics',
      INTEGRATION: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-integrations',
      DRIVE: 'http://dls-asgard-thor-1453383019.us-west-2.elb.amazonaws.com/lb-drive'
    }
  },
  CUP: {
    ALPHA: {
      PUB: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-pub',
      AUTH: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-auth',
      AUTHEXTN: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-authextn',
      PUSHX: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-pushx',
      XAPI: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-xapi',
      ATTEMPTS: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-attempts',
      PRODUCT: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-product',
      ANALYTICS: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-analytics',
      INTEGRATION: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-integrations',
      DRIVE: 'http://dls-cup-alpha-2093819659.us-west-2.elb.amazonaws.com/lb-drive'
    },
    PROD1: {
      PUB: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-pub',
      AUTH: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-auth',
      AUTHEXTN: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-authextn',
      PUSHX: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-pushx',
      XAPI: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-xapi',
      ATTEMPTS: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-attempts',
      PRODUCT: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-product',
      ANALYTICS: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-analytics',
      INTEGRATION: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-integrations',
      DRIVE: 'http://internal-dls-cup-prod1-284466545.us-west-2.elb.amazonaws.com/lb-drive'
    },
    QA: {
      PUB: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-pub',
      AUTH: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-auth',
      AUTHEXTN: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-authextn',
      PUSHX: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-pushx',
      XAPI: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-xapi',
      ATTEMPTS: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-attempts',
      PRODUCT: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-product',
      ANALYTICS: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-analytics',
      INTEGRATION: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-integrations',
      DRIVE: 'http://internal-dls-cup-qa-41690511.us-west-2.elb.amazonaws.com/lb-drive'
    },
    HFX: {
      PUB: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-pub',
      AUTH: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-auth',
      AUTHEXTN: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-authextn',
      PUSHX: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-pushx',
      XAPI: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-xapi',
      ATTEMPTS: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-attempts',
      PRODUCT: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-product',
      ANALYTICS: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-analytics',
      INTEGRATION: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-integrations',
      DRIVE: 'http://internal-dls-cup-hfx-908523553.us-west-2.elb.amazonaws.com/lb-drive'
    },
    REL: {
      PUB: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-pub',
      AUTH: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-auth',
      AUTHEXTN: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-authextn',
      PUSHX: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-pushx',
      XAPI: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-xapi',
      ATTEMPTS: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-attempts',
      PRODUCT: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-product',
      ANALYTICS: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-analytics',
      INTEGRATION: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-integrations',
      DRIVE: 'http://internal-dls-cup-rel-1458752944.us-west-2.elb.amazonaws.com/lb-drive'
    }
  }
};

exports.AUTH_API_URLS = {
    getSettings: '/org/{orgId}/settings',
    getTokenAPI: '/auth/{orgId}/token',
    getExtUserTokenAPI: '/auth/{orgId}/ext-users/token',
    userInfoAPI: '/org/{orgId}/users/{userId}',
    pisImportAPI: '/org/{orgId}/pis_imports',
    getAllUsersAPI: '/org/{orgId}/users/all',
    updateUserRoleAPI: '/org/{orgId}/users/{userId}/update-role',
    getSettingsField: '/org/{orgId}/settings/{field}',
    getClassUsersAPI: '/org/{orgId}/class/{classId}/users',
    getUserClassesAPI: '/org/{orgId}/users/{userId}/classes',
    getUserClassesV2API: '/org/{orgid}/users/{userid}/class-enrollments',
    getAllJobs: '/accounts/{accountId}/ext-users/{extUserId}/jobs',
    getJob: '/accounts/{accountId}/ext-users/{extUserId}/jobs/{jobId}',
    getAllClassesAPI: '/org/{orgId}/classes',
    getParticularClassAPI: '/org/{orgId}/classes/{classId}',
    getParticularShadowClassAPI: '/org/{orgId}/shadow/classes/{extClassId}',
    classProductAssociation: '/org/{orgId}/classes/{classId}/associate-product/{productcode}',
    multiClassProductAssociations: '/org/{orgId}/classes/{classId}/associate-product/multi',
    classMaterialAssociation: '/org/{orgId}/classes/{classId}/associate-materials/multi',
    enrollUsertoClass: '/org/{orgId}/classes/{classId}/enroll-user/{userId}',
    enrollSelftoClass: '/org/{orgId}/classes/{classId}/enroll-self',
    enrollMultiUserstoClass: '/org/{orgId}/classes/{classId}/enroll-user/multi',
    createClass: '/org/{orgId}/classes',
    createMultipleClasses: '/org/{orgId}/classes/multi',
    specificClass: '/org/{orgId}/classes/{classId}',
    cloneClass: '/org/{orgId}/classes/{classId}/clone',

    ClassAppdata: '/org/{orgId}/classes/{classid}/appdata',

    generateClassCode: '/org/{orgId}/classes/{classId}/class-code/generate',

    // spaces related API
    getUserSpaces: '/accounts/{accountid}/ext-users/{extuserid}/spaces',
    validateSpaceCode: '/accounts/{accountid}/space-code/validate',
    validateClassCode: '/accounts/{accountid}/class-code/validate',
    joinInstituteSpace: '/accounts/{accountid}/join-institute-space',
    provisionSpacesToStudent: '/accounts/{accountId}/student/provision-spaces',
    provisionSpacesToTeacher: '/accounts/{accountId}/teacher/provision-spaces',
    shadowProvision: '/org/{orgId}/shadow-provision',
    provisionBulkSpaces: '/org/{orgId}/provision-spaces/bulk',
    entitleUserToProduct: '/accounts/{accountId}/entitle-user',
    microEntitleUserToProduct: '/accounts/{accountId}/entitle-user/micro',
    bulkMicroEntitleProductToUser: '/accounts/{accountId}/entitle-user/micro/bulk',
    enrollUserInClass: '/accounts/{accountId}/enroll-with-classcode',
    getExtProductAPI: '/accounts/{accountId}/products/{extProductId}',
    getSpaceDetails: '/accounts/{accountId}/spaces/{spacekey}',
    updateUserInformation: '/accounts/{accountId}/update-user-information',
    updateUserSpace: '/accounts/{accountid}/ext-users/{extuserid}/spaces/{spacekey}',
    getInvitationsByEmail: '/accounts/{accountid}/invitations-by-email',
    generateSpaceCode: '/accounts/{accountid}/space-code/generate',
    changeSpaceCode: '/accounts/{accountid}/space-code/{spacecode}/change',
    updateInstituteTitle: '/accounts/{accountId}/institute-spaces/{instituteSpaceCode}',

    //Superuser related API
    getAllInstitutions: '/su/accounts/{accountid}/spaces',
    getInstitution: '/su/accounts/{accountid}/spaces/{spacecode}',
    provisionSpacesToSuperAdmin: '/su/accounts/{accountid}/superadmin/provision-spaces',

    //Superuser related API
    sendInvitations: '/org/{orgId}/invitations',
    getMultiInvitations: '/org/{orgId}/invitations',
    getSingleInvitation: '/org/{orgId}/invitations/{invitationId}',
    revokeSingleInvitation: '/org/{orgId}/invitations/{invitationid}/revoke',
    completeSingleInvitation: '/org/{orgId}/invitations/{invitationid}/complete',
    resendSingleInvitation: '/org/{orgId}/invitations/{invitationid}/resend',
    //AssignedPath related API
    createAssignedPath: '/org/{orgId}/classes/{classId}/assigned-paths',
    deleteAssignedPath: '/org/{orgId}/classes/{classId}/assigned-paths/{assignedPathId}',

    //Workflows related APIs
    workflows: '/accounts/{accountid}/workflows',
    getAllWorkflowOfAUser: '/accounts/{accountid}/workflows/workflows-by-user',
    getAWorkflow: '/accounts/{accountid}/workflows/{workflowid}',
    acceptAWorkflow: '/accounts/{accountid}/workflows/{workflowid}/accept',
    processAWorkflow: '/accounts/{accountid}/workflows/{workflowid}/process',
    revokeAWorkflow: '/accounts/{accountid}/workflows/{workflowid}/revoke',
    completeAWorkflow: '/accounts/{accountid}/workflows/{workflowid}/complete',

    //Groups realated APIs
    allGroups: '/org/{orgId}/groups',
    aParticularGroup: '/org/{orgId}/groups/{groupId}',
    getAllMembersOfAGroup: '/org/{orgId}/groups/{groupId}/memberships',
    getAllGroupMembersByPath: '/org/{orgId}/groups/memberships',
    userGroupMembership: '/org/{orgId}/groups/{groupId}/enroll-user/multi',
    getMyAllMemberships: '/org/{orgId}/users/{userId}/groups',
    archiveAParticularGroup: '/org/{orgId}/groups/{groupId}/archive',
    unarchiveAParticularGroup: '/org/{orgId}/groups/{groupId}/unarchive',

    //Showcase related API's
    showcaseItems: '/org/{orgId}/classes/{classId}/showcase/item',

    //Data-Sync-Manager related APIs
    createDataSyncManager: '/accounts/{accountid}/data-sync-managers',
    dataSyncManager: '/accounts/{accountid}/data-sync-managers/{dsmid}',
    getAllDataSyncManagersOfAGroup: '/accounts/{accountid}/dsm-groups/{dsm_groupid}/data-sync-managers',

    //Gradebooks related APIs
    createOrGetGradebookMeta: '/org/{orgId}/classes/{classId}/gradebooks',
    updateOrDeleteGradebookMeta: '/org/{orgId}/classes/{classId}/gradebooks/{gradebook_id}',
    gradebookColumns: '/org/{orgId}/classes/{classId}/gradebooks/{gradebook_id}/columns',
    getAllClassesOfAComponent: '/org/{orgId}/components/{component_code}/classes',
    removeAllGradebookColumnsOfCustomComponent: '/org/{orgId}/gradebook/columns/custom-components/{component_code}',

    // Custom Components related APIs
    customComponents: '/org/{orgid}/custom-components',
    particularCustomComponent: '/org/{orgid}/custom-components/{custom_component_code}'
};

exports.AUTHEXTN_API_URLS = {
    // Grade Formats related APIs
    gradeFormat: '/org/{orgid}/gradeformats',
    particularGradeFormat: '/org/{orgid}/gradeformats/{gradeformat_id}',
    classGradeformatAssociation: '/org/{orgid}/classes/{classid}/associate-gradeformats/{gradeformat_id}',
    classGradeformats: '/org/{orgid}/classes/{classid}/gradeformats',
    gradeformatClasses: '/org/{orgid}/gradeformats/{gradeformat_id}/classes',

    //Space related API
    entitleBulkUsersToProducts: '/accounts/{accountid}/entitle-users/bulk',

    // Assigned Path APIs
    userAssignedPaths: '/org/{orgid}/classes/{classid}/assigned-paths/{assignedpathid}/enroll-user/multi',

    // Class related APIs
    particularClass: '/org/{orgId}/classes/{classId}',

    // Org Entitlement related APIs
    orgProductEntitlement: '/org/{orgid}/org-entitlements',
    setupUser: '/accounts/{accountId}/user/setup'

};

exports.ACTIVITY_API_URLS = {
    newAttemptAPI: '/{orgId}/products/{productId}/activities/{activityId}/start',
    activityDetailsAPI: '/{orgId}/products/{productId}/activities/{activityId}',
    existingAttemptAPI: '/{orgId}/products/{productId}/activities/{activityId}/attempts/{attemptId}',
    userResponseAPI: '/{orgId}/products/{productId}/activities/{activityId}/attempts/{attemptId}/response',
    submitAttemptAPI: '/{orgId}/products/{productId}/activities/{activityId}/attempts/{attemptId}/submit'
};

exports.ANALYTICS_API_URLS = {
    archiveUserAnalytics: '/{orgId}/archive/user/product',
    getOrgAnalyticsStat: '/{orgId}/organization/{type}/stat',
    getAnalyticProductItems: '/{orgId}/user/product/progress/items',
    getAnalyticProductSummary: '/{orgId}/user/product/progress/summary',
    getExternalDataForUserAnalyticItem: '/{orgId}/user/product/progress/items/external-data',
    searchUserProductAnalytics: '/{orgId}/user/product/progress/search',
    getAnalyticProductById: '/{orgId}/user/product/userprogress/{userProgressId}',
    getArchivedUserAnalytics: '/{orgId}/archive',
    getClassAnalytics: '/{orgId}/class/{analyticsDataType}/{type}',
    getClassEnrolmentsStat: '/{orgId}/class/enrolments/stat',
    getClassRecord: '/{orgId}/class/product/class-record',
    getClassRecordItemAggregations: '/{orgId}/class/product/item-aggregations',
    getClassProductRecentPendingSubmissions: '/{orgId}/class/product/recent-pending-submissions',
    getStudentsWithEvaluatedOnce: '/{orgId}/class/product/students-with-evaluations',
    getShowcaseRecordOfAClass: '/{orgId}/class/showcase',

    getGroupRecord: '/{orgId}/class/group/product/group-record',
    getClassGroupsRecentPendingSubmissions: '/{orgId}/class/group/product/recent-pending-submissions',
    getGroupsWithEvaluatedOnce: '/{orgId}/class/group/product/groups-with-evaluations',

    getClassRecordUserAggregations: '/{orgId}/class/product/user-aggregations',
    getUserClassRecentSubmissions: '/{orgId}/user/product/class/recent-submissions',
    appState: '/{orgId}/user/product/progress/state',
    getUserProductAllState: '/{orgId}/user/product/progress/state/all',
    updateUserProductMultiState: '/{orgId}/user/product/progress/state/multi',

    //AssignedPaths Related APIs
    getAllAssignedPathsOfClass: '/{orgId}/class/assigned-paths',
    getMyAssignedPathsOfClass: '/{orgId}/user/class/assigned-paths',
    getAssignedPathAnalytics: '/{orgId}/class/assigned-paths/aggregations',

    timeseriesAnalytics: '/progress/timeseries',

    //ClassCustomComponentRecord Related APIs
    getClassCustomComponentRecord: '/{orgId}/class/custom-component/class-record',
    getClassCustomComponentUserSubmission: '/{orgId}/class/custom-component/class-record/evaluations',

    //CrossProductAggregation Related APIs
    getCrossProductAggregation: '/{orgId}/class/cross-product-aggregation'
};

exports.COLLAB_API_URLS = {
    postsInClassAPI: '/{orgId}/post/classes/{classId}',
    postsInProductAPI: '/{orgId}/post/products/{productId}',
    getMyFollowers: '/{orgId}/connections/me/followers',
    getUsersFollowedByMe: '/{orgId}/connections/me/following',
    connectionURL: '/{orgId}/connections/me/follow/{userId}'
};

exports.PRODUCT_API_URLS = {
    getProductAPI: '/accounts/{accountId}/products/{productCode}',
    getEntitlementsOfAUser: '/accounts/{accountId}/ext-users/{extUserId}/entitlements',
    getMicroEntitlementsOfAUser: '/accounts/{accountId}/ext-users/{extUserId}/entitlements/micro',
    getAllBundles: '/accounts/{accountId}/bundles',
    getSingleBundle: '/accounts/{accountId}/bundles/{bundleCode}',
    getAllProductFamilies: '/accounts/{accountId}/families',
    getSingleProductFamily: '/accounts/{accountId}/families/{familyCode}'
};

exports.XAPI_API_URLS = {
    postMultiStatements: '/{orgId}/statements/multi',
    postExternalMultiStatements: '/{orgId}/external/statements/multi'
};

exports.ATTEMPTS_API_URLS = {
  userAttempts: '/org/{orgId}/user/{userId}/activities/{activityId}/attempts',
  getUserAttemptStatsForActivity: '/org/{orgId}/user/{userId}/activities/{activityId}/attempts/stats',
  getUserAttemptForActivity: '/org/{orgId}/user/{userId}/activities/{activityId}/attempts/{attemptId}',
  getUserFirstAttemptForActivity: '/org/{orgId}/user/{userId}/activities/{activityId}/attempts/first',
  getUserLastAttemptForActivity: '/org/{orgId}/user/{userId}/activities/{activityId}/attempts/last',
  getUserActivityMeta: '/org/{orgId}/user/{userId}/activities/{activityId}/meta'
};

exports.PUB_API_URLS = {
    promoteAPI: '/{orgId}/products/{productcode}/promote',
    registerProductAPI: '/{orgId}/products/register',
    ingestByCodeAPI: '/{orgId}/products/{productcode}/ingest',
    createBundle: '/{orgid}/stage/{stage}/bundles',
    updateBundle: '/{orgid}/stage/{stage}/bundles/{bundleCode}',
    getAllBundles: '/{orgid}/bundles',
    getSingleBundle: '/{orgid}/bundles/{bundleCode}',
    createProductFamily: '/{orgid}/stage/{stage}/families',
    updateProductFamily: '/{orgid}/stage/{stage}/families/{familyCode}',
    getSingleProductFamily: '/{orgid}/families/{familyCode}',
    getAllProductFamilies: '/{orgid}/families'
};

exports.PUSHX_API_URLS = {
    grantByUserOrgId: '/orgs/{orgId}/grants',
    grantByAccountId: '/accounts/{accountId}/grants',
    grantV2: '/ver/v2/grants',
    getPushedEvents: '/accounts/{accountId}/pushed-events/channels'
};

exports.INTEGRATIONS_API_URLS = {
  getGetStreamCredentials: '/accounts/{accountId}/getstream/credentials',
  queryDataFromSearch: '/search/indices/{index}',
  auditTrail: '/accounts/{accountId}/audit-trail',
  customEvents: '/accounts/{accountId}/custom-events',
  schedules: '/accounts/{accountId}/context/{context}/schedule',
  particularSchedule: '/accounts/{accountId}/context/{context}/schedule/{scheduleId}'
};

exports.DRIVE_API_URLS = {
  getAParticularDocument: '/accounts/{accountid}/users/{extuserid}/documents/{documentid}',
  getAllDocumentsInAFolder: '/accounts/{accountid}/users/{extuserid}/documents',
  documents: '/accounts/{accountid}/users/{userid}/documents/multi'
};

exports.TAXONOMY_API_URLS = {
  associateTagsWithEntity: '/org/{orgId}/taxonomy/associate-tags-with-entity',
  tags: '/org/{orgId}/context/{context}/taxonomy/{taxonomyId}/tags'
};

exports.RULES_API_URLS = {
  rules: '/org/{orgId}/context/{context}/rule_type/{ruleType}/rules',
  particularRule: '/org/{orgId}/context/{context}/rule_type/{ruleType}/rules/{ruleId}',
  updateRuleDisplay: '/org/{orgId}/context/{context}/rule_type/{ruleType}/rules/{ruleId}/update-rule-display',
  getUserRule: '/org/{orgId}/context/{context}/rule_type/{ruleType}/users/{userId}/rules'
};
